// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"107":"edf81b6b","291":"7e6e0e90","344":"c3c4ba96","514":"d8020097","787":"1ed0c42c"}[chunkId] + ".chunk.js";
};